import { useNavigate } from "react-router-dom";

const CustomBreadCrumbs = ({ crumbs }) => {
  const navigate = useNavigate();
  return (
    <article className="container-fluid">
      <div className="p-3 pb-0  mt-1">
        <h6>{"  "}
          {crumbs?.map(({ title, link }, index) => (
            <div className="d-inline-block" key={index}>
            &nbsp;  <span
                className={link?.length ? "linkClick" : undefined}
                role={"button"}
                onClick={() => link?.length && navigate(link)}
              >
                {title}
              </span>{"  "}
              {crumbs?.length - 1 === index ? null : <>/ </>}
            </div>
          ))}
        </h6>
      </div>
    </article>
  );
};

export default CustomBreadCrumbs;
